var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoulders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 280",
    width: 1000,
    height: 280,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fbc3a4}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m56.9 268.1c-44.3-4.8-42.1-44.4-41-107.7 1.1-64.3 37.4-104.3 80.1-116.3 355.6-100.1 300.8 38.3 115.9 99.9-61 20.3 22.4 142.9-155 124.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m943.8 271.1c44.3-4.8 42.1-44.4 41-107.7-1.1-64.3-37.4-104.3-80-116.3-355.7-100.1-300.9 38.3-116 99.9 61 20.3-22.4 142.9 155 124.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoulders);
export default __webpack_public_path__ + "static/media/shoulders.b098ecf6ad17dd49086f613fbfa8b2d2.svg";
export { ForwardRef as ReactComponent };